module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.aea7c27f.svg";